import React from 'react';

const DateInput = ({ value, onChange, t, idPrefix = 'bz' }) => {
  const currentYear = new Date().getFullYear();
  const dateValue = value.year && value.month && value.day
    ? `${value.year}-${String(value.month).padStart(2, '0')}-${String(value.day).padStart(2, '0')}`
    : '';
  const timeValue = value.hour !== '' && value.hour !== undefined && value.minute !== '' && value.minute !== undefined
    ? `${String(value.hour).padStart(2, '0')}:${String(value.minute).padStart(2, '0')}`
    : '';

  const handleDateChange = (val) => {
    if (!val) {
      onChange({ ...value, year: '', month: '', day: '' });
      return;
    }
    const match = val.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return;
    onChange({
      ...value,
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
    });
  };

  const handleTimeChange = (val) => {
    if (!val) {
      onChange({ ...value, hour: '', minute: '' });
      return;
    }
    const match = val.match(/^(\d{2}):(\d{2})$/);
    if (!match) return;
    onChange({
      ...value,
      hour: Number(match[1]),
      minute: Number(match[2]),
    });
  };

  return (
    <fieldset className="bz-fieldset">
      <legend className="bz-fieldset__legend">{t('birthDateTime')}</legend>

      <div className="bz-date-grid bz-date-grid--picker">
        <div className="fc-field">
          <label className="fc-label" htmlFor={`${idPrefix}-birth-date`}>{t('compatBirthDateLabel')}</label>
          <input
            id={`${idPrefix}-birth-date`}
            className="fc-input"
            type="date"
            min="1900-01-01"
            max={`${currentYear}-12-31`}
            value={dateValue}
            onChange={(e) => handleDateChange(e.target.value)}
          />
        </div>
      </div>

      <div className="bz-time-grid">
        <div className="fc-field">
          <label className="fc-label" htmlFor={`${idPrefix}-birth-time`}>{t('compatBirthTimeLabel')}</label>
          <input
            id={`${idPrefix}-birth-time`}
            className="fc-input"
            type="time"
            step="60"
            value={timeValue}
            onChange={(e) => handleTimeChange(e.target.value)}
          />
        </div>
      </div>
    </fieldset>
  );
};

export default DateInput;
